import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import phoneIcon from "../../assets/phone-icon.svg"
import { Form } from "../Form/Form";


export function Contact(){

  return(
    <Container id="contact">
      <header>
        <h2>Contact</h2>
        <p>Hire Me </p>
      </header>
      <div className="contacts">
        <div>
        <a href="mailto:raviranjan251@gmail.com"><img src={emailIcon} alt="Email" /></a> 
          <a href="mailto:raviranjan251@gmail.com">raviranjan251@gmail.com</a>
        </div>
        <div>
        <a href="tel:+919630576848"><img src={phoneIcon} alt="Phone No" /></a>
          <a href="tel:+919630576848">(+91) 9986026027</a>
        </div>  
      </div>
    </Container>
  )
}


